/**
 * @param {Response} response
 * @param {string} fileName (including extension) - optional, defaults to "standings.png"
 * @param {boolean} isShare - optional, defaults to true
 */
const sanitizeFileName = (name) => name.replace(/[/\\:*?"<>|]/g, "_").trim();

export async function socialImageDownload(
  response,
  fileName = "standings.png",
  isShare = true,
) {
  fileName = sanitizeFileName(fileName);
  if (!response.ok) {
    throw new Error("Failed to generate image");
  }

  const blob = await response.blob();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  let shared = false;
  if (isMobile && navigator.share && isShare) {
    try {
      const file = new File([blob], fileName, { type: "image/png" });
      await navigator.share({ files: [file] });
      shared = true;
    } catch (shareErr) {
      console.error("share failed:", shareErr.name, shareErr.message);
      if (shareErr.name === "AbortError") shared = true;
    }
  }
  if (!shared) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}

export const TOURNAMENT_POSTER_IMAGE_URL =
  "https://tournifyapp.com/api/share-image/tournament";
